import { BlacklistTypes } from 'redux/actionTypes/blacklistTypes';

export const BlacklistActions = {
  setAllCompanies: (companiesArray: []) => {
    return {
      type: BlacklistTypes.setAllCompanies,
      payload: companiesArray,
    };
  },
  setOneCompany: (companyObject: {}) => {
    return {
      type: BlacklistTypes.setOneCompany,
      payload: companyObject,
    };
  },
  setCompanyToEdit: (companyToEditId: number) => {
    return {
      type: BlacklistTypes.setCompanyToEdit,
      payload: companyToEditId,
    };
  },
  setFilteredCompanies: (filteredCompaniesArray: []) => {
    return {
      type: BlacklistTypes.setFilteredCompanies,
      payload: filteredCompaniesArray,
    };
  },
  editCompany: (companyObject: {}) => {
    return {
      type: BlacklistTypes.editCompany,
      payload: companyObject,
    };
  },
  removeCompany: (companyId: number | null) => {
    return {
      type: BlacklistTypes.removeCompany,
      payload: companyId,
    };
  },
  setReasons: (reasonsArray: []) => {
    return {
      type: BlacklistTypes.setReasons,
      payload: reasonsArray,
    };
  },
  setCountries: (countriesArray: []) => {
    return {
      type: BlacklistTypes.setCountries,
      payload: countriesArray,
    };
  },
  setManagers: (managersArray: []) => {
    return {
      type: BlacklistTypes.setManagers,
      payload: managersArray,
    };
  },
  addNewFile: (filesArray: any[] | null, companyId: number | undefined) => {
    return {
      type: BlacklistTypes.addNewFile,
      payload: {
        filesArray: filesArray,
        companyId: companyId,
      },
    };
  },
  removeFile: (fileId: number, fileName: string, companyId: number) => {
    return {
      type: BlacklistTypes.removeFile,
      payload: {
        fileId: fileId,
        fileName: fileName,
        companyId: companyId,
      },
    };
  },
};
